import { switchMap } from 'rxjs/operators';
import { AppEpic } from '../../../types';
import { getApi } from '../../api';
import { setLocaleAction } from '../slices/app.slice';

export const localeEpic: AppEpic = (action$, state$) =>
  getApi().locale$.pipe(
    switchMap((locale) => [setLocaleAction(locale || 'en')]),
  );
